// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
//
import Axios from 'axios';
import sortBy from 'lodash/sortBy';

import Comment, { CommentDTO } from '@shared/models/comment';
import { COMMENT_FIELDS } from '@shared/constants/comment';

export default class CommentsService {

  // Load list of comments from portal-api into a class var.
  async getList(url: string): Promise<Array<Comment>> {
    const { data } = await Axios.get<Array<CommentDTO>>(url);

    return sortBy(data, COMMENT_FIELDS.createdDate).map(((comment) => new Comment(comment)));
  }

  // Should this be async?
  send = (url: string, comment: Partial<CommentDTO> & {exceptionCode: string}) => {
    return Axios.post(url, comment);
  }
}